module.exports = __webpack_public_path__ + "static/media/smaller.72433fba.png";